export default __webpack_public_path__ + "static/media/magnifying-glass-plus.1ed92f5c.svg";